import React from 'react'
import Header from '../components/Header'
import Builder from '../components/Builder'

function Teambuilder() {
    return (
        <>
            <Header />
            <Builder />
        </>
    )
}

export default Teambuilder